import * as React from 'react';
import { Divider, ListItemButton, ListItemIcon, ListItemText, ListSubheader } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import HomeIcon from '@mui/icons-material/Home';
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

const TeacherSideBar = ({ onSwipe }) => {
    const { currentUser } = useSelector((state) => state.user);
    const sclassName = currentUser?.teachSclass?.sclassName || "";
    const location = useLocation();
    const [touchStart, setTouchStart] = React.useState(0);
    const [touchEnd, setTouchEnd] = React.useState(0);
    const [isVisible, setIsVisible] = React.useState(false);
    const minSwipeDistance = 50;

    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        if (Math.abs(distance) > minSwipeDistance) {
            setIsVisible(!isVisible);
        }
        setTouchStart(0);
        setTouchEnd(0);
    };

    return (
        <div 
            className={`sidebar ${isVisible ? 'visible' : 'hidden'}`}
            onTouchStart={handleTouchStart} 
            onTouchMove={handleTouchMove} 
            onTouchEnd={handleTouchEnd}
        >
            <ListItemButton component={Link} to="/teacher/dashboard">
                <ListItemIcon>
                    <HomeIcon color={location.pathname === "/teacher/dashboard" ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Home" />
            </ListItemButton>
            
            <ListItemButton component={Link} to="/teacher/class">
                <ListItemIcon>
                    <ClassOutlinedIcon color={location.pathname.startsWith("/teacher/class") ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary={`Class ${sclassName}`} />
            </ListItemButton>
            
            <ListItemButton component={Link} to="/teacher/complain">
                <ListItemIcon>
                    <AnnouncementOutlinedIcon color={location.pathname.startsWith("/teacher/complain") ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Complain" />
            </ListItemButton>

            <ListItemButton component={Link} to="/teacher/add-note">
                <ListItemIcon>
                    <NoteAddIcon color={location.pathname === "/teacher/add-note" ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Add Notes" />
            </ListItemButton>
            
            <Divider sx={{ my: 1 }} />
            
            <ListSubheader component="div" inset>User</ListSubheader>
            <ListItemButton component={Link} to="/teacher/profile">
                <ListItemIcon>
                    <AccountCircleOutlinedIcon color={location.pathname.startsWith("/teacher/profile") ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Profile" />
            </ListItemButton>
            
            <ListItemButton component={Link} to="/logout">
                <ListItemIcon>
                    <ExitToAppIcon color={location.pathname === "/logout" ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Logout" />
            </ListItemButton>
        </div>
    );
};

export default TeacherSideBar;
